import React, { useState } from 'react';
import classnames from 'classnames';
import { InputMask } from '@react-input/mask';
import { FormRenderFieldType, TimepickerProps } from 'types/TextField';
import {
  FloatingLabel, Form, FormControl, InputGroup,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function Timepicker( {
  value,
  placeholder,
  classNames = {},
  onChange,
  isInvalid,
  disabled,
  style,
  label,
  translateLabel = true,
  appendIcon,
  onClickAppendIcon,
  showErrors = true,
  meta,
  validateTranslateValues,
}: TimepickerProps & FormRenderFieldType ) {
  const { t } = useTranslation();
  const [focused, setFocused] = useState( false );

  return (
    <Form.Group className={classnames( 'form-group', classNames.formGroup, {
      'is-invalid': isInvalid,
    } )}
    >
      <InputGroup>
        {label
          ? (
            <FloatingLabel
              label={translateLabel && typeof label === 'string' ? t( label ) : label}
            >
              <InputMask
                value={value}
                mask="__/__/____"
                placeholder={placeholder ? t( placeholder ) : ' '}
                replacement={{
                  _: /[0-9]/,
                }}
                showMask
                className={classnames( 'form-control', {
                  'is-invalid': isInvalid,
                } )}
                disabled={disabled}
                style={style}
                onChange={( event: any ) => {
                  if ( onChange ) onChange( event.target.value );
                }}
                onFocus={() => setFocused( true )}
                onBlur={() => setFocused( false )}
              />
            </FloatingLabel>
          )
          : (
            <InputMask
              value={value}
              mask="__/__/____"
              placeholder={placeholder ? t( placeholder ) : ' '}
              replacement={{
                _: /[0-9]/,
              }}
              showMask
              className={classnames( 'form-control', {
                'is-invalid': isInvalid,
              } )}
              disabled={disabled}
              style={style}
              onChange={( event: any ) => {
                if ( onChange ) onChange( event.target.value );
              }}
              onFocus={() => setFocused( true )}
              onBlur={() => setFocused( false )}
            />
          )}

        {appendIcon && (
        <InputGroup.Text
          className={classnames( appendIcon, {
            'cursor-pointer': !!onClickAppendIcon,
            focused,
          } )}
          onClick={onClickAppendIcon}
        />
        )}
      </InputGroup>

      {showErrors
      && (
        <FormControl.Feedback type="invalid">
          {isInvalid ? t( meta?.error || meta?.submitError, validateTranslateValues ) || ' ' : ''}
        </FormControl.Feedback>
      )}
    </Form.Group>

  );
}

export default Timepicker;
